import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { updateTimeSettings } from 'store/reducers/inputReducer';
import { selectTimeSetting } from 'store/reducers/selectors';

import { STATIC_TABLE_SETTINGS } from 'store/reducers/constants/constants.js';

const TableUseTimeWindowsCheck = (props) => {
    const dispatch = useDispatch();
    const tableTimeSettings = STATIC_TABLE_SETTINGS[props.tableName]['timeWindows'];
    const timeUseTimeWindows = useSelector(selectTimeSetting("useTimeWindows", props.tableName));

    const handleUseTimeWindowsChange = () => {
        dispatch(updateTimeSettings({settingNames:['useTimeWindows'], tableName:props.tableName, settingValues:[!timeUseTimeWindows]}));
    }

    if (timeUseTimeWindows === null || timeUseTimeWindows === undefined) return null;

    // The description is a real <label htmlFor> tied to the checkbox: clicking it
    // toggles natively (no onClick needed), and screen readers announce it as the
    // checkbox's name — the old clickable <span> gave neither.
    const checkboxId = `use-time-windows-${props.tableName}`;

    return (
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '4px 0' }}>
            <Checkbox
                id={checkboxId}
                checked={Boolean(timeUseTimeWindows)}
                onChange={handleUseTimeWindowsChange}
                style={{ marginTop: '2px', flexShrink: 0 }}
            />
            <label
                htmlFor={checkboxId}
                style={{ fontSize: '14px', color: '#525f7f', lineHeight: '1.5', cursor: 'pointer', userSelect: 'none', marginBottom: 0 }}
            >
                {tableTimeSettings?.description}
            </label>
        </div>
    );
}

TableUseTimeWindowsCheck.propTypes = {
    tableName: PropTypes.string.isRequired,
};

export default TableUseTimeWindowsCheck;
